/* unplugin-vue-components disabled */import { render } from "./TaiChiItem.vue?vue&type=template&id=4365c33a&scoped=true"
import script from "./TaiChiItem.vue?vue&type=script&lang=js"
export * from "./TaiChiItem.vue?vue&type=script&lang=js"

import "./TaiChiItem.vue?vue&type=style&index=0&id=4365c33a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4365c33a"]])

export default __exports__